// Third party modules;
import React from 'react';

// HelpBot admin modules;
import Body from './Body';
import Foot from './Foot';
import Head from './Head';
import Menu from './Menu';

const View = () => {

   return(

      <div className="ask-henry">
        <Head />
        <Menu />
        <Body />
        <Foot />
      </div>

   );

} // View();

export default View;